import React from "react";
import stockPhoto from "../stockphoto.jpg";

const AboutMe = () => {
  return (
    <div className="flex flex-col items-center py-10 min-h-screen">
      <h1 className="text-6xl font-medium mb-5">About Me</h1>
      {/* image */}
      <img src={stockPhoto} alt="profilepic" className="w-96 h-56 my-10" />
      {/*"about me" section */}
      <div className="bg-blue-200 min-w-56 max-w-96 font-bold flex justify-center px-5">
        HELLO EVERYONE I"M A PERSON
      </div>
      {/* bio */}
      <p className="w-96 px-5">
        I’m passionate about building web applications that make a difference.
        With a background in both design and development, I enjoy bridging the
        gap between beautiful interfaces and functional code. When I’m not
        coding, you can find me exploring the latest design trends or working on
        personal projects that focus on sustainability and accessibility.
      </p>
      {/* hobbies and interests */}
      {/* To make a list:
      <ul>
        <li>item</li>
        <li>item</li>
      </ul> */}
      {/* <div className="bg-blue-500">
        <h1>Hobbies and interests</h1>
        <ul>
          <li>First thing</li>
          <li>second</li>
        </ul>
      </div> */}
    </div>
  );
};

export default AboutMe;
